
import { Component, Prop, Vue, Provide, Inject } from 'vue-property-decorator'
import { reportEntryLog } from '@xt/client/utils/log'
import EmptyStatus from '@xt/www/components/emptyStatus/index.vue'
import { EnumEmptyStatus } from '@xt/client/utils/empty-status/index'
import { EnumRequestError } from '@xt/client/experimental/request/interceptors'

@Component({
  components: {
    EmptyStatus
  }
})
export default class extends Vue {
  @Prop() error

  option: {
    type: number
    marginTop?: number
    showBackButton?: boolean
    message?: string
  } = {
    type: EnumEmptyStatus.PageNotFound,
    marginTop: 120,
    showBackButton: true
  }

  message: string

  get EnumEmptyStatus() {
    return EnumEmptyStatus
  }

  get status() {
    if (this.error.statusCode === 200) {
      return '500'
    }

    // 映射网络异常状态码
    if (this.error.errCode === EnumRequestError.NETWORK_ERROR) {
      return '408'
    }

    return String(this.error.statusCode)
  }

  refreshPage() {
    window.location.reload()
  }

  get production() {
    return this.$store.$global.production
  }

  get path() {
    return this.$route.path
  }

  get query() {
    return this.$route.query
  }

  init() {
    // 生产环境避开代码等错误提示
    if (this.production && parseInt(this.status, 10) >= 500) {
      this.option = {
        ...this.option,
        type: EnumEmptyStatus.NotRecoverableError,
        message: '数据异常，请联系客服'
      }
      this.message = '数据异常，请联系客服'
      return
    }

    // 错误路由页面
    if (this.status === '404') {
      this.option = {
        ...this.option,
        type: EnumEmptyStatus.PageNotFound
      }
      this.message = '找不到页面'
      return
    }

    // 网络异常｜拿不到状态码
    if (this.status === '408') {
      this.option = {
        ...this.option,
        type: EnumEmptyStatus.NetworkError
      }
      this.message = '网络开小差了，刷新一下试试吧'
      return
    }

    // 处理499 和 405错误
    if (this.status === '405') {
      this.option = {
        ...this.option,
        type: EnumEmptyStatus.NotRecoverableError,
        message: '数据异常，请联系客服'
      }
      this.message = '数据异常，请联系客服'
      return
    }

    if (this.status === '499') {
      this.option = {
        ...this.option,
        type: EnumEmptyStatus.NetworkError,
        message: '服务端繁忙，请刷新试试吧'
      }
      this.message = '服务端繁忙，请刷新试试吧'
      return
    }

    this.option = {
      ...this.option,
      type: EnumEmptyStatus.NotRecoverableError,
      message: this.error.message
    }
    this.message = this.error.message
  }

  created() {
    console.log('LENG: extends -> created -> this', this)

    this.init()

    // 上报错误日志
    reportEntryLog('app.layout.error', {
      path: this.path,
      query: this.query,
      message: this.message,
      status: this.status,
      error: this.error
    })
  }
  mounted() {}
  updated() {}
  destroyed() {}
}
